// useUpdateUserSettingsApi.ts
import { useMutation } from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';

export type UpdateUserSettingsPayload = {
  allow_challenge?: boolean;
  chessboard_theme?: string; // e.g. "default-yellow-white"
};

export type UpdateUserSettingsResponse = {
  success: boolean;
  data?: {
    allow_challenge: boolean;
    chessboard_theme: string;
  };
  error?: string;
  errors?: Record<string, string>;
};

export default function useUpdateUserSettingsApi(
  handleOnSuccess?: (data: UpdateUserSettingsResponse) => void,
  handleOnError?: (data: UpdateUserSettingsResponse) => void
) {
  const mutation = useMutation<UpdateUserSettingsResponse, Error, UpdateUserSettingsPayload>(
    async (payload) => {
      const res = await ChessRestClient.post('learning/update_user_settings/', payload);
      return res.data as UpdateUserSettingsResponse;
    },
    {
      onSuccess: (data) => {
        if (handleOnSuccess && data?.success) handleOnSuccess(data);
        else if (handleOnError && !data?.success) handleOnError(data);
      },
    }
  );

  return {
    ...mutation,
    updateSettings: mutation.mutate,            // call with payload
    updateSettingsAsync: mutation.mutateAsync,  // awaitable version
  };
}
